import React from 'react';
import { bool, string } from 'prop-types';
import ArrowRight from '../icons/right-arrow';
import AngleRight from '../icons/angle-right';

import './view-all.m.css';

const ViewAll = ({ label, color, isTitle = false, ...props }) =>
  isTitle ? (
    <div styleName="wrapper" {...props}>
      <div styleName="mobile-view-all" className="desktop-hidden">
        <ArrowRight color="sixth-color" />
      </div>
      <span styleName="desktop-view-all" className="mobile-hidden">
        <AngleRight color="second-color" fontSize="16px" className='center-align'/>
      </span>
    </div>
  ) : (
    <div styleName="wrapper" {...props} style={{color:`var(--${color})`}}>
      {label || 'View All'}
      <ArrowRight color={color} />
    </div>
  );

ViewAll.propTypes = {
  label: string,
  color: string,
  isTitle: bool
};

ViewAll.defaultProps = {
  color: 'var(--fourth-color)'
};
export default ViewAll;
